import React from 'react';
import '../assets/css/Footer.css'; 
import logo from '../assets/images/logo.svg';  
import Facebook from '../assets/images/Facebook.svg';  
import Linkedin from '../assets/images/Linkedin.svg';  
import Instagram from '../assets/images/Instagram.svg';  



const Footer = () => (
  <footer className="footer" id="footer">
  <div className="footer-container">
    <div className="footer-logo">
      <img src={logo} alt="Company Logo"/>
    </div>
    <div className="footer-links">
      <h3>Quick Links</h3>
      <ul>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About Us</a></li>
        <li><a href="#services">Services</a></li>
        {/* <li><a href="#">Privacy Policy</a></li>
        <li><a href="#">Terms of Service</a></li> */}
      </ul>
    </div>
    <div className="footer-contact">
      <h3>Contact Information</h3>
      <p><a href="mailto:info@company.com?subject=Inquiry">info@codelithiclabs.com</a></p>
      <p>106 Aquila Drive,Calgary, AB, Canada</p>
    </div>
    <div className="footer-social">
      <h3>Follow Us</h3>
      <ul>
        <li><a href="https://www.facebook.com/people/Codelithic-Labs-Inc/61571775761064/" target='_blank' className="social-icon"><img src={Facebook} alt="Facebook"/></a></li>
        <li><a href="https://ca.linkedin.com/company/codelithic-labs-inc" target='_blank' className="social-icon"><img src={Linkedin} alt="LinkedIn"/></a></li>
        <li><a href="https://www.instagram.com/codelithiclabs/" target='_blank' className="social-icon"><img src={Instagram} alt="Instagram"/></a></li>
      </ul>
    </div>
  </div>
  <div className="footer-bottom">
    <p>&copy; 2025 Codelithic Labs Inc. All rights reserved.</p>
  </div>
</footer>

);

export default Footer;
